import { useState } from 'react';

import type { Placement } from '@popperjs/core';
import { usePopper } from 'react-popper';

export function useTooltip(placement: Placement, offset: [number, number]) {
  const [referenceElement, setReferenceElement] = useState<HTMLElement | null>(null);

  const [popperElement, setPopperElement] = useState<HTMLElement | null>(null);

  const { styles, update } = usePopper(referenceElement, popperElement, {
    placement,
    modifiers: [
      {
        name: 'offset',
        options: {
          offset,
        },
      },
    ],
  });

  return {
    tooltipStyles: styles.popper,
    setReferenceElement,
    setPopperElement,
    update,
  };
}
